import { SelectionField } from './../../selection-field'
import { CheckboxFieldProps } from './CheckboxField.types'

export function CheckboxField({
  label,
  supportingText,
  id,
  disabled,
  className,
  variant = 'transparent',
  error,
  ...rest
}: CheckboxFieldProps) {
  return <SelectionField label={label} supportingText={supportingText} disabled={disabled} className={className} variant={variant} select="checkbox" {...rest} error={error} />
}
